import React from 'react'

import { PodRef, TudoAli } from 'assets/img/card-icons'
import { groups } from 'constants/pod-groups'

import {
    Container,
    Title,
    SubTitle,
    Item,
    Icon,
    Content
} from './ProductTooltip.style'

const ProductTooltipAliRef = () => (
    <Container data-testid={`${groups.ALIMENTACAO_REFEICAO}Tooltip`}>
        <Title>O QUE É O ALIMENTAÇÃO E REFEIÇÃO?</Title>
        <Content>
            <Item>
                <div>
                    <Icon src={TudoAli} alt="Icone Alelo Pod Alimentação" />
                </div>
                <p>
                    <SubTitle>Alimentação:</SubTitle>
                    <br /> Benefício utilizado para a compra de
                    <br /> alimentos em ampla rede credenciada de
                    <br /> supermercados, açougues, quitandas e
                    <br /> similares.
                </p>
            </Item>
            <Item>
                <div>
                    <Icon src={PodRef} alt="Icone Alelo Pod Refeição" />
                </div>
                <p>
                    <SubTitle>Refeição:</SubTitle>
                    <br /> Benefício voltado ao pagamento das
                    <br /> refeições em ampla rede credenciada,
                    <br /> que inclui restaurantes, lanchonetes e
                    <br /> similares.
                </p>
            </Item>
        </Content>
    </Container>
)

export default ProductTooltipAliRef
